// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2Fklt","validationTips":"StatementDescriptor_validationTips__4fPKW"};